import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import About from "./Aboutcomp";
import { Link } from "react-router-dom";
import Testimonials from "./Testimonials";
import Slider from "react-slick";
import ContactForm from "./ContactFrom";
import MainHeader from "./MainHeader";
import aboutImg from "../components/Team2.jpg"
import HomeTeam from "./HomeTeam";

export default function Home() {

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 2,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  // ────────────── Stats Counter Logic ──────────────
  const statsRef = useRef(null);
  const [counts, setCounts] = useState({
    year: 0,
    happy: 0,
    active: 0,
    projects: 0,
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          const animateValue = (start, end, duration, setterKey) => {
            let startTime = null;
            const step = (timestamp) => {
              if (!startTime) startTime = timestamp;
              const progress = Math.min((timestamp - startTime) / duration, 1);
              const value = Math.floor(progress * (end - start) + start);
              setCounts(prev => ({ ...prev, [setterKey]: value }));
              if (progress < 1) {
                requestAnimationFrame(step);
              }
            };
            requestAnimationFrame(step);
          };

          animateValue(0, 2016, 1800, "year");
          animateValue(0, 550, 1800, "happy");
          animateValue(0, 20, 1800, "active");
          animateValue(0, 500, 1800, "projects");

          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    AOS.init();
  }, []);
const timelineRef = useRef(null);
const pathRef = useRef(null);

useEffect(() => {
  const path = pathRef.current;
  const timeline = timelineRef.current;
  if (!path || !timeline) return;

  const length = path.getTotalLength();
  path.style.strokeDasharray = length;

  // restore progress
  const saved = localStorage.getItem("whyChooseProgress");
  path.style.strokeDashoffset = saved ? saved : length;

  const onScroll = () => {
    const rect = timeline.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const progress =
      (windowHeight - rect.top) / (rect.height + windowHeight * 0.5);

    const clamped = Math.min(Math.max(progress, 0), 1);
    const draw = length * (1 - clamped);

    path.style.strokeDashoffset = draw;
    localStorage.setItem("whyChooseProgress", draw);
  };

  window.addEventListener("scroll", onScroll);
  onScroll();

  return () => window.removeEventListener("scroll", onScroll);
}, []);


  return (
    <div style={{ overflowX: "hidden" }}>
      <MainHeader />
      <About />

      {/* Start Services Section */}
      <div id="services" className="services services-bg" >
        <div className="services-overlay">
          <div className="container">
            <div className="section-title">
              <div className="d-flex justify-content-center">
                <h2 className="text-center">Services</h2>
              </div>
              <h3 className="text-center"> We Provide <span> Exclusive Services</span> <br /> For Your Business</h3>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
                <div className="card icon-box py-3">
                  <div className="card-body p-4">
                    <div className="shape-icon">
                      <i className="bi bi-globe icon"></i>
                      <span className="circle"></span>
                    </div>
                    <div className="service-card_number">01</div>
                    <p className="mt-4 pFont">
                      Web Design & Development</p>
                    <p className="mt-4">
                      Elevate your online presence with captivating web designs and
                      seamless development expertise.
                    </p>
                    <div className=" mt-4">
                      <Link to="/web-development-services">
                        {" "}
                        <button type="button" className="btn px-3 py-2">
                          <span className="d-none"> Know about Web Design & Development</span> <i className="fas fa-arrow-right rightServiceArrow" style={{ color: "initial" }}></i>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-5 mt-md-0">
                <div className="icon-box card py-3">
                  <div className="card-body p-4">
                    <div className="shape-icon">
                      <i className="bi bi-window-sidebar icon"></i>
                      <span className="circle"></span>
                    </div>
                    <div className="service-card_number">02</div>
                    <p className="mt-4 pFont">
                      Software Development
                    </p>
                    <p className="mt-4">
                      From concept to code, we craft tailored software solutions
                      that drive efficiency and innovation.
                    </p>
                    <div className=" mt-4">
                      <Link to="/software-development-services">
                        {" "}
                        <button type="button" className="btn px-3 py-2">
                          <span className="d-none"> Learn about Software Development</span> <i className="fas fa-arrow-right rightServiceArrow" style={{ color: "initial" }}></i>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-5 mt-lg-0">
                <div className="icon-box card py-3">
                  <div className="card-body p-4">
                    <div className="shape-icon">
                      <i className="bi bi-phone-flip icon"></i>
                      <span className="circle"></span>
                    </div>
                    <div className="service-card_number">03</div>
                    <p className="mt-4 pFont">
                      Mobile Apps Development</p>
                    <p className="mt-4">
                      Innovative mobile development for seamless experiences,
                      enhancing engagement and digital footprint.
                    </p>
                    <div className=" mt-4">
                      <Link to="/mobile-app-development-services">
                        {" "}
                        <button type="button" className="btn px-3 py-2">
                          <span className="d-none"> Our Mobile Apps Development Service</span> <i className="fas fa-arrow-right rightServiceArrow" style={{ color: "initial" }}></i>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-5">
                <div className="icon-box card py-3">
                  <div className="card-body p-4">
                    <div className="shape-icon">
                      <i className="bi bi-megaphone icon"></i>
                      <span className="circle"></span>
                    </div>
                    <div className="service-card_number">04</div>
                    <p className="mt-4 pFont">
                      <span>Digital Marketing</span>
                    </p>
                    <p className="mt-4">
                      Strategic digital marketing amplifying your brand, driving
                      growth, and captivating your target audience.
                    </p>
                    <div className=" mt-4">
                      <Link to="/digital-marketing-services">
                        <button type="button" className="btn px-3 py-2">
                          <span className="d-none">Explore Our Digital Marketing Services</span> <i className="fas fa-arrow-right rightServiceArrow" style={{ color: "initial" }}></i>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-5">
                <div className="icon-box card py-3">
                  <div className="card-body p-4">
                    <div className="shape-icon">
                      <i className="bi bi-search-heart icon"></i>
                      <span className="circle"></span>
                    </div>
                    <div className="service-card_number">05</div>
                    <p className="mt-4 pFont">
                      SEO Services</p>
                    <p className="mt-4">
                      Optimize visibility and drive traffic with our result-oriented
                      SEO strategies and expert implementation.
                    </p>
                    <div className=" mt-4">
                      <Link to="/seo-services">
                        {" "}
                        <button type="button" className="btn px-3 py-2">
                          <span className="d-none">Discover Our SEO Services</span> <i className="fas fa-arrow-right rightServiceArrow" style={{ color: "initial" }}></i>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-5">
                <div className="icon-box card py-3">
                  <div className="icon-box card-body p-4">
                    <div className="shape-icon">
                      <i className="bi bi-palette icon"></i>
                      <span className="circle"></span>
                    </div>
                    <div className="service-card_number">06</div>
                    <p className="mt-4 pFont">
                      Graphics Designing
                    </p>
                    <p className="mt-4">
                      Impactful graphics translating ideas into stunning designs,
                      leaving lasting impressions for your visual needs.
                    </p>
                    <div className=" mt-4">
                      <Link to="/graphics-designing-services">
                        <button type="button" className="btn px-3 py-2">
                          <span className="d-none"> Do You Need Designs</span> <i className="fas fa-arrow-right rightServiceArrow" style={{ color: "initial" }}></i>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 d-flex justify-content-center align-items-center">
                <Link to="/services">
               <button className="primaryBtn px-4 py-2 mb-3 mt-4">
  View All &rarr;
</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Services Section */}

{/* Why Choose Us - Zigzag pattern with proper spacing */}
<div className="why-choose-us-horizontal py-4" style={{ background: "linear-gradient(135deg, #f8f9fa, #ffffff)" }}>
  <div className="container">
    <div className="section-title text-center mb-4" data-aos="fade-up">
      <div className="d-flex justify-content-center">
        <h2>Why Choose Us</h2>
      </div>
      <h3>
        Innovative thinking and unmatched <span>expertise</span> at every stage
      </h3>
    </div>

    <div className="timeline-horizontal position-relative" ref={timelineRef} style={{ minHeight: "280px" }}>
      {/* Connecting zigzag line */}
      <svg
        className="connecting-line position-absolute w-100"
        style={{ height: "100%", top: "0", left: "0" }}
        viewBox="0 0 1200 280"
        preserveAspectRatio="none"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          ref={pathRef}
          d="M 80 70 
             L 240 70
             L 240 210
             L 400 210
             L 400 70
             L 560 70
             L 560 210
             L 720 210
             L 720 70
             L 880 70
             L 880 210
             L 1040 210
             L 1040 70
             L 1120 70"
          stroke="#684df4"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          opacity="0.85"
        />
      </svg>

      <div className="steps-wrapper position-relative">
        {/* Step 1 - Top */}
        <div className="step step-top" style={{ left: "6%" }} data-aos="fade-up" data-aos-delay="100">
          <div className="step-circle mx-auto">
            <div className="circle-inner">
              <i className="bi bi-eye-fill"></i>
            </div>
            <span className="step-number">1</span>
          </div>
          <h5 className="mt-2 mb-1">Empathize</h5>
          <p className="small mb-0">Your vision</p>
        </div>

        {/* Step 2 - Bottom */}
        <div className="step step-bottom" style={{ left: "20%" }} data-aos="fade-up" data-aos-delay="150">
          <div className="step-circle mx-auto">
            <div className="circle-inner">
              <i className="bi bi-journal-text"></i>
            </div>
            <span className="step-number">2</span>
          </div>
          <h5 className="mt-2 mb-1">Craft</h5>
          <p className="small mb-0">On paper</p>
        </div>

        {/* Step 3 - Top */}
        <div className="step step-top" style={{ left: "33%" }} data-aos="fade-up" data-aos-delay="200">
          <div className="step-circle mx-auto">
            <div className="circle-inner">
              <i className="bi bi-diagram-3-fill"></i>
            </div>
            <span className="step-number">3</span>
          </div>
          <h5 className="mt-2 mb-1">Plan</h5>
          <p className="small mb-0">Results</p>
        </div>

        {/* Step 4 - Bottom */}
        <div className="step step-bottom" style={{ left: "47%" }} data-aos="fade-up" data-aos-delay="250">
          <div className="step-circle mx-auto">
            <div className="circle-inner">
              <i className="bi bi-bricks"></i>
            </div>
            <span className="step-number">4</span>
          </div>
          <h5 className="mt-2 mb-1">Architecture</h5>
          <p className="small mb-0">Foundation</p>
        </div>

        {/* Step 5 - Top */}
        <div className="step step-top" style={{ left: "60%" }} data-aos="fade-up" data-aos-delay="300">
          <div className="step-circle mx-auto">
            <div className="circle-inner">
              <i className="bi bi-rocket-takeoff-fill"></i>
            </div>
            <span className="step-number">5</span>
          </div>
          <h5 className="mt-2 mb-1">Delivery</h5>
          <p className="small mb-0">Quality</p>
        </div>

        {/* Step 6 - Bottom */}
        <div className="step step-bottom" style={{ left: "73%" }} data-aos="fade-up" data-aos-delay="350">
          <div className="step-circle mx-auto">
            <div className="circle-inner">
              <i className="bi bi-bug-fill"></i>
            </div>
            <span className="step-number">6</span>
          </div>
          <h5 className="mt-2 mb-1">Testing</h5>
          <p className="small mb-0">Aggressive</p>
        </div>

        {/* Step 7 - Top */}
        <div className="step step-top" style={{ left: "87%" }} data-aos="fade-up" data-aos-delay="400">
          <div className="step-circle mx-auto">
            <div className="circle-inner">
              <i className="bi bi-person-gear"></i>
            </div>
            <span className="step-number">7</span>
          </div>
          <h5 className="mt-2 mb-1">Support</h5>
          <p className="small mb-0">Ongoing</p>
        </div>
      </div>
    </div>
  </div>

  <style jsx>{`
    .why-choose-us-horizontal {
      position: relative;
    }

    .timeline-horizontal {
      overflow-x: auto;
      overflow-y: visible;
      padding: 15px 0;
    }

    .connecting-line {
      z-index: 1;
      pointer-events: none;
    }

    .steps-wrapper {
      position: relative;
      z-index: 2;
      width: 100%;
      height: 280px;
      min-width: 1100px;
    }

    .step {
      position: absolute;
      width: 110px;
      text-align: center;
      transform: translateX(-50%);
    }

    .step-top {
      top: 0;
    }

    .step-bottom {
      bottom: 0;
    }

    .step-circle {
      width: 70px;
      height: 70px;
      position: relative;
      margin: 0 auto;
    }

    .circle-inner {
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, #684df4);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 6px 20px rgba(121, 13, 253, 0.3);
      transition: all 0.3s ease;
    }

    .step:hover .circle-inner {
      transform: scale(1.08);
      box-shadow: 0 10px 30px rgba(121, 13, 253, 0.4);
    }

    .circle-inner i {
      font-size: 1.5rem;
      color: white;
    }

    .step-number {
      position: absolute;
      top: -5px;
      right: -5px;
      width: 26px;
      height: 26px;
      background: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      color: #790dfd;
      font-size: 0.8rem;
      border: 2px solid #790dfd;
      box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    }

    .step h5 {
      font-size: 0.95rem;
      font-weight: 700;
      color: #333;
      margin-bottom: 3px;
    }

    .step p {
      font-size: 0.75rem;
      color: #666;
      line-height: 1.2;
      margin: 0;
    }

    @media (max-width: 1100px) {
      .steps-wrapper {
        min-width: auto;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 25px;
        padding: 20px 0;
      }
      
      .step {
        position: relative !important;
        transform: none !important;
        left: auto !important;
        top: auto !important;
        bottom: auto !important;
        width: 120px;
      }
      
      .connecting-line {
        display: none;
      }
    }
  `}</style>
</div>

{/* Product Ecosystem Section */}
<section className="product-ecosystem py-5">
  <div className="container">
    <div className="section-title text-center mb-5">
      <h2>Our Product Ecosystem</h2>
      <h3>
        Smart software products built to <span>grow your business</span>
      </h3>
    </div>

    <div className="row g-4">
      {/* CapoBrain */}
    <div className="col-md-6 col-lg-4">
  <a
    href="/school-management-system"
    target="_self"
    className="card-link"
  >
    <div className="ecosystem-card">
      <img
        src="/capobrain.png"
        alt="CapoBrain ERP Business Software"
        className="product-img"
      />
     
      <p>
     Comprehensive school management system to streamline administration,
        academics, and student management efficiently.
      </p>
      <span className="tag">Education</span>
    </div>
  </a>
</div>


      {/* CapoBiz */}
      <div className="col-md-6 col-lg-4">
          <a
    href="/business-management-solutions"
    target="_self"
    className="card-link"
  >
        <div className="ecosystem-card">
          <img
            src="/capobiz.avif"
            alt="CapoBiz POS Management System"
            className="product-img"
          />
         
          <p>
            Smart POS and business management solution for small and medium-sized
            businesses.
          </p>
          <span className="tag">Business</span>
        </div>
     </a>
      </div>

      {/* Restaurant Management System */}
      <div className="col-md-6 col-lg-4">
        <a
          href="/restuarent-management-system"
          target="_self"
          className="card-link"
        >
        <div className="ecosystem-card">
          <img
            src="/restuarent.png"
            alt="Restaurant Management Software"
            className="product-img"
          />
          
          <p>
      An efficient system for managing restaurant operations, orders, staff, inventory, and daily workflows.

          </p>
          <span className="tag">Restaurant </span>
        
        </div>
          </a>
      </div>
    </div>
  </div>
</section>


      {/* stats section start - no background + counter */}
{/* stats section start - modern pattern + counter */}
<div ref={statsRef} className="stats-modern-section py-5">
  <div className="container">
    {/* Section Heading */}
    <div className="section-title text-center mb-5">
      <h3 className="text-dark">
        Our Achievements <span>In Numbers</span>
      </h3>
    </div>

    <div className="row text-center g-4">
      {/* Card 1 */}
      <div className="col-md-6 col-lg-3">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bi bi-calendar-event"></i>
          </div>
          <h2>{counts.year}</h2>
          <p>Established In</p>
        </div>
      </div>

      {/* Card 2 */}
      <div className="col-md-6 col-lg-3">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bi bi-people"></i>
          </div>
          <h2>{counts.happy}+</h2>
          <p>Happy Clients</p>
        </div>
      </div>

      {/* Card 3 */}
      <div className="col-md-6 col-lg-3">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bi bi-headset"></i>
          </div>
          <h2>{counts.active}+</h2>
          <p>Active Clients</p>
        </div>
      </div>

      {/* Card 4 */}
      <div className="col-md-6 col-lg-3">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bi bi-journal-richtext"></i>
          </div>
          <h2>{counts.projects}+</h2>
          <p>Projects Delivered</p>
        </div>
      </div>
    </div>
  </div>
</div>
{/* stats section end */}


      {/* stats section end */}

      {/* Start Clients Logo Section - Marquee */}
      <section id="clients" className="clients py-1" style={{ backgroundColor: "transparent" }}>
        <div className="container">
          <div className="section-title text-center mb-0">
           
             <h3>  Our Trusted <span> Clients</span></h3>
          </div>

          <div style={{
            overflow: "hidden",
            width: "100%",
            position: "relative",
          }}>
            <div style={{
              display: "flex",
              animation: "marquee 40s linear infinite",
              whiteSpace: "nowrap",
            }}>
              {/* First set */}
              <img src="assets/img/clients/client-homepainting-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-farooqgraphics-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-almahdia-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/K2Land-LOGO.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-almakah-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-mobilefiksers-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-punjabestate-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-lettechnologies-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-sheikhlaw-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-capobrain-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-getwellpk-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-photonics-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-paradise-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-capobiz-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-intermarket-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />

              {/* Duplicate set for seamless loop */}
              <img src="assets/img/clients/client-homepainting-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-farooqgraphics-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-almahdia-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/K2Land-LOGO.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-almakah-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-mobilefiksers-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-punjabestate-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-lettechnologies-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-sheikhlaw-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-capobrain-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-getwellpk-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-photonics-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-paradise-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-capobiz-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
              <img src="assets/img/clients/client-intermarket-logo.avif?v=3" alt="client" style={{ height: "80px", margin: "0 20px", flexShrink: 0 }} />
            </div>
          </div>
        </div>

        <style>{`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </section>
      {/* End Clients Logo Section */}

      {/* Start Products Section */}
      <section id="featured-services" className="productservice">
        <div className="container">
          <div className="section-title text-center mb-3">
            <h2> Our Products</h2>
            <h3>  Explore Our Best <span> Software Products</span></h3>
          </div>
          <div className="row g-4">
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch">
              <div className="card icon-box productCard">
                <div className="card-body">
                  <i className="bi bi-mortarboard"></i>
                  <p>
                    <strong>School Management System</strong></p>
                  <p>
                    An all-in-one solution for your school management system activities
                  </p>
                  <div>
                    <Link to="/school-management-system">
                      {" "}
                      <button type="button" className="btn px-3 py-2">
                        <i className="fas fa-arrow-right rightServiceArrow"></i>
                      </button>
                      <span className="d-none"><span className="d-none"> Education Management System-Capobrain</span></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 d-flex align-items-stretch">
              <div className="card icon-box productCard">
                <div className="card-body">
                  <i className="bi bi-bag-check"></i>
                  <p>
                    <strong>Business Management Solution</strong></p>
                  <p>
                    Seamlessly manage all resources for your large enterprise
                  </p>
                  <div>
                    <Link to="/business-management-solutions">
                      {" "}
                      <button type="button" className="btn px-3 py-2">
                        <i className="fas fa-arrow-right rightServiceArrow"></i>
                      </button>
                      <span className="d-none"><span className="d-none">erp-solutions</span></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 d-flex align-items-stretch">
              <div className="card icon-box productCard">
                <div className="card-body">
                  <i className="bi bi-bag-check"></i>
                  <p>
                    <strong>Ecommerce Solutions</strong></p>
                  <p>
                    Leverage the Ecommerce solutions for the businesses of all sizes, to seamlessly sealing your product online
                  </p>
                  <div>
                    <Link to="/ecommerce-solutions">
                      {" "}
                      <button type="button" className="btn px-3 py-2">
                        <i className="fas fa-arrow-right rightServiceArrow"></i>
                      </button>
                      <span className="d-none"><span className="d-none"> Explore ecommerce solutions</span></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 d-flex align-items-stretch">
              <div className="card icon-box productCard">
                <div className="card-body">
                  <i className="bi bi-pc-display-horizontal"></i>
                  <p>
                    <strong>Point Of Sale</strong>
                  </p>
                  <p>
                    Manage your daily sales, transactions, inventory and monitor your cash flow with our POS system
                  </p>
                  <div>
                    <Link to="/restuarent-management-system">
                      {" "}
                      <button type="button" className="btn px-3 py-2">
                        <i className="fas fa-arrow-right rightServiceArrow"></i>
                      </button>
                      <span className="d-none"><span className="d-none"> capobiz-point of sale software</span></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-center align-items-center">
              <Link to="/products">
<button className="primaryBtn px-4 py-2 mb-3">
  Explore all Products &rarr;
</button>



              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* End Products Section */}

      <Testimonials />
      <HomeTeam />
      <ContactForm />
    </div >
  );
}